import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { ErrorBanner, SuccessBanner } from "../components/ui";
import { BrandLockup } from "../components/BrandLockup";

export function PasswordResetRequestPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      <header className="bg-white border-b-2 border-tora-accent">
        <div className="mx-auto max-w-7xl px-4 py-3">
          <BrandLockup />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="card w-full max-w-md p-6 md:p-8 shadow-md">
          <p className="text-[11px] text-tora tracking-widest font-semibold">
            PASSWORD RESET
          </p>
          <h1 className="text-2xl md:text-3xl font-bold text-tora-ink mt-1.5">
            パスワード再設定
          </h1>
          <p className="text-sm text-tora-ink/70 mt-1 mb-6">
            登録メールアドレスを入力してください。再設定用のリンクをお送りします。
          </p>

          {done ? (
            <>
              <SuccessBanner>
                ご入力のアドレス宛にメールをお送りしました (該当の会員登録が
                あった場合)。30 分以内にメール内のリンクから再設定してください。
              </SuccessBanner>
              <p className="mt-4 text-xs text-tora-ink/60">
                数分経ってもメールが届かない場合は、迷惑メールフォルダをご確認のうえ、
                送信者ドメインを受信許可してください。
              </p>
              <p className="mt-5 text-center">
                <Link
                  to="/login"
                  className="tap-target text-sm text-tora hover:underline"
                >
                  ログイン画面へ戻る
                </Link>
              </p>
            </>
          ) : (
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                setErr(null);
                setBusy(true);
                try {
                  await api.post("/auth/password-reset/request", { email });
                  setDone(true);
                } catch (e) {
                  setErr(
                    (e as Error).message ??
                      "送信に失敗しました。時間を置いて再度お試しください。",
                  );
                } finally {
                  setBusy(false);
                }
              }}
            >
              <div className="mb-4">
                <label className="label" htmlFor="pwrst-email">
                  メールアドレス
                </label>
                <input
                  id="pwrst-email"
                  type="email"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  inputMode="email"
                  autoFocus
                  placeholder="例: yamada@example.com"
                />
              </div>
              {err && <ErrorBanner className="mb-3">{err}</ErrorBanner>}
              <button className="btn-primary btn-lg w-full" disabled={busy}>
                {busy ? "送信中…" : "再設定メールを送る →"}
              </button>
              <p className="mt-5 text-center">
                <Link
                  to="/login"
                  className="tap-target text-sm text-tora-ink/60 hover:text-tora"
                >
                  ログイン画面へ戻る
                </Link>
              </p>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
